import React from "react";

// Butoanele filtrelor: „Aplică filtre” (submit; Enter în câmpuri face la fel) și „Șterge filtrele”.
// `f` = rezultatul lui `useFilters`. Se pune în interiorul unui <form onSubmit={f.submit}> — vezi FilterForm.
export default function FilterActions({ f, testid = "filters" }) {
  return (
    <>
      <button type="submit" className="btn btn-primary" data-testid={`${testid}-apply`}>Aplică filtre</button>
      {(f.active || f.dirty) && (
        <button type="button" className="btn btn-secondary" onClick={f.reset} data-testid={`${testid}-clear`}>Șterge filtrele</button>
      )}
      {f.dirty && <span style={{ fontSize: 12, color: "#92400E", alignSelf: "center" }} data-testid={`${testid}-pending`}>Filtrele alese nu sunt aplicate încă.</span>}
    </>
  );
}

// Formular de filtre: Enter aplică; nimic nu se filtrează la simpla alegere dintr-o listă.
export function FilterForm({ f, children, testid = "filters", className = "card", style }) {
  return (
    <form className={className} style={style} data-testid={testid}
      onSubmit={e => { e.preventDefault(); f.apply(); }}>
      {children}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}><FilterActions f={f} testid={testid} /></div>
    </form>
  );
}
